import { v4 } from "uuid";
import type { FormValues } from "./validation-schema";

export const defaultDiagnosis = (): FormValues["diagnosis"][number] => ({
  key: v4(),
  codification: {
    name: "",
    category: "",
    code: "",
  },
  disease: "",
  freeText: false,
});

export const defaultValues: () => FormValues = () => ({
  problem: "",
  presentingComplaint: "",
  symptoms: [],
  plan: "",
  diagnosis: [defaultDiagnosis()],
  prescriptions: [],
  investigations: [],
  nonPharmaItems: [],
});
